/**
 * Teacher Preview Routes
 *
 * Route configuration for the content preview feature.
 * Wraps all preview pages in PreviewProvider context.
 */

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { PreviewProvider } from "../../../context/PreviewContext";

// Preview Pages
import ContentPreviewLanding from "./ContentPreviewLanding";
import ProgramWeekOverview from "./ProgramWeekOverview";
import WeekModuleView from "./WeekModuleView";
import ModulePreview from "./Modulepreview";
// import ModulePreview from "./ModulePreview"; // TODO: Create this component

/**
 * Placeholder for Module Preview page (Phase 2)
 * This will show the actual learning content and quiz with answers
 */
const ModulePreviewPlaceholder: React.FC = () => {
  return (
    <div style={{ padding: 24 }}>
      <h2>Module Preview</h2>
      <p>
        Coming soon: Full module content and quiz preview with answer toggle.
      </p>
    </div>
  );
};

const TeacherPreviewRoutes: React.FC = () => {
  return (
    <PreviewProvider>
      <Routes>
        {/* Landing page - shows all 3 programs */}
        <Route index element={<ContentPreviewLanding />} />

        {/* Program overview - shows all weeks for a program */}
        <Route path=":program" element={<ProgramWeekOverview />} />

        {/* Week overview - shows all 7 modules for a week */}
        <Route path=":program/week/:weekNumber" element={<WeekModuleView />} />

        {/* Module preview - shows learning content + quiz with answers */}
        <Route
          path=":program/week/:weekNumber/:moduleType"
          element={<ModulePreview />}
        />

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/teacher/preview" replace />} />
      </Routes>
    </PreviewProvider>
  );
};

export default TeacherPreviewRoutes;
